import React from 'react';
import { connect } from 'react-redux';
import { compose } from '@beef/redux';
import { IconImportFilled } from '@carnica/graphics';
import { Spinner, Text } from '@carnica/ui-kit';
import { cnBem } from "../../../../shared/lib";
import { useImageView, withMessageWrapper } from "../../lib";
import { setStoreImgPreview } from "../../model";
import { addStoreImageUrlGroup } from "../../../content/model";
import { REFRESH_TEXT } from "../../../../shared/config";
import styles from "./styles.pcss";
var cnImageView = cnBem('image', styles);
var Loader = function Loader() {
  return /*#__PURE__*/React.createElement(Spinner, {
    className: cnImageView('spinner'),
    view: "yellow-white"
  });
};
var ImageEmptyContent = function ImageEmptyContent(_ref) {
  var isRefresh = _ref.isRefresh;
  return isRefresh ? /*#__PURE__*/React.createElement(Text, {
    align: "center",
    color: "secondary",
    size: "xs"
  }, REFRESH_TEXT) : /*#__PURE__*/React.createElement(IconImportFilled, {
    className: cnImageView('empty_icon'),
    color: "primary-invert",
    size: "m"
  });
};
var ImageViewRender = function ImageViewRender(_ref2) {
  var message = _ref2.message,
    setImgPreview = _ref2.setImgPreview,
    setImgUrl = _ref2.setImgUrl;
  var _useImageView = useImageView({
      message: message,
      setImgPreview: setImgPreview,
      setImgUrl: setImgUrl
    }),
    filePreviewUrl = _useImageView.filePreviewUrl,
    handleCLick = _useImageView.handleCLick,
    isLoading = _useImageView.isLoading,
    isRefresh = _useImageView.isRefresh;
  return /*#__PURE__*/React.createElement("div", {
    className: cnImageView('wrapper', {
      loading: isLoading
    }),
    onClick: handleCLick
  }, isLoading && /*#__PURE__*/React.createElement(Loader, null), filePreviewUrl ? /*#__PURE__*/React.createElement("img", {
    alt: "",
    className: cnImageView('image', {
      loading: isLoading
    }),
    src: filePreviewUrl
  }) : /*#__PURE__*/React.createElement("div", {
    className: cnImageView('empty', {
      loading: isLoading,
      refresh: isRefresh && !!filePreviewUrl
    })
  }, !isLoading && /*#__PURE__*/React.createElement(ImageEmptyContent, {
    isRefresh: isRefresh
  })));
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    setImgPreview: function setImgPreview(imgData) {
      return dispatch(setStoreImgPreview(imgData));
    },
    setImgUrl: function setImgUrl(imageUrlGroup) {
      return dispatch(addStoreImageUrlGroup(imageUrlGroup));
    }
  };
};
export var ImageView = compose(connect(null, mapDispatchToProps), withMessageWrapper({
  bordered: true,
  dateView: 'img-block',
  offset: 'none',
  wrapperClassName: cnImageView()
}))(ImageViewRender);